export const SIGN_IN_LEDGER_MODAL_HIDE = 'SIGN_IN_LEDGER_MODAL_HIDE';
export const SIGN_IN_LEDGER_MODAL_SHOW = 'SIGN_IN_LEDGER_MODAL_SHOW';
export const SET_LEDGER_INFO = 'SET_LEDGER_INFO';
export const SET_LEDGER_ACCOUNT_NUMBER = 'SET_LEDGER_ACCOUNT_NUMBER';
export const SET_LEDGER_ACCOUNT_INDEX = 'SET_LEDGER_ACCOUNT_INDEX';
